import {computed} from 'vue'

export const useSessionIntegrationLink = integration => {
	const integrationUrl = computed(() => {
		if (!integration) return ''
		const {commentId, url, type} = integration
		if (!commentId) return url
		if (type === 'azure') return url + '#' + commentId
		else if (type === 'github') return url + '#issuecomment-' + commentId
		else if (type === 'jira') return url + '?focusedCommentId=' + commentId
		else return url
	})

	const tooltipText = computed(() => {
		if (!integration) return ''
		const integrationDisplayNames = {
			jira: 'Jira',
			github: 'GitHub',
			linear: 'Linear',
			slack: `#${integration.state}`,
		}
		return `View in ${integrationDisplayNames[integration.type]}`
	})

	const buttonText = computed(() => {
		if (!integration) return ''
		const {state, url, type, commentId} = integration
		if (type === 'slack') {
			return `View in #${state}`
		}
		const urlSplitted = url.split('/')
		if (type === 'linear') {
			let idInUrl
			if (commentId) idInUrl = urlSplitted[urlSplitted.length - 1].split('#')[0]
			else idInUrl = urlSplitted[urlSplitted.length - 2]
			return `${state} - ${idInUrl}`
		}
		// extracting issue id from the url. Url's either have id as last item /<id> or has a trailing slash /<id>/, except linear,
		// In case of linear we return early above
		const idInUrl = urlSplitted[urlSplitted.length - 1] || urlSplitted[urlSplitted.length - 2]
		if (type === 'github') {
			const stateString = state ? `- ${state.toLowerCase()}` : ''
			return `#${idInUrl} ${stateString}`
		}
		return `${idInUrl}`
	})

	return {
		integrationUrl,
		tooltipText,
		buttonText,
	}
}
